<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M604 1263 c-30 -6 -65 -46 -73 -84 -6 -31 -7 -32 -66 -33 l-60 -1 -3
-32 -3 -33 219 0 c120 0 221 3 224 6 3 3 3 17 -1 32 -7 25 -12 27 -56 27 -48
0 -49 1 -56 34 -12 58 -67 95 -125 84z m51 -93 c0 -18 -6 -26 -23 -28 -24 -4
-38 18 -28 44 3 9 15 14 28 12 17 -2 23 -10 23 -28z"
      />
      <path
        d="M151 1154 c-21 -26 -21 -36 -21 -528 0 -569 -5 -537 80 -555 66 -14
594 -15 585 -1 -4 6 -100 10 -253 10 l-247 1 33 29 c18 17 38 30 46 30 21 0
102 38 116 55 18 21 13 20 -85 -25 -77 -36 -95 -41 -149 -38 l-61 3 -3 493 -2
492 88 0 c81 0 88 2 97 23 8 18 20 23 75 28 42 3 4 6 -107 7 l-172 2 -20 -26z"
      />
      <path
        d="M805 1171 c56 -6 60 -8 63 -33 l3 -28 90 0 89 0 0 -80 c0 -79 0 -80
25 -80 25 0 25 1 25 89 0 74 -3 92 -21 115 l-20 26 -157 -2 c-102 -1 -136 -3
-97 -7z"
      />
      <path
        d="M249 985 c0 -3 -1 -23 -1 -45 0 -22 1 -60 1 -85 l1 -45 85 0 85 0 0
90 0 90 -85 0 c-47 0 -85 -2 -86 -5z m161 -85 l0 -70 -75 0 -75 0 0 70 0 70
75 0 75 0 0 -70z"
      />
      <path
        d="M320 935 c0 -8 -7 -15 -15 -15 -8 0 -15 -9 -15 -20 0 -11 7 -20 15
-20 8 0 15 -7 15 -16 0 -10 7 -14 18 -12 9 2 16 10 15 16 -2 7 4 12 12 12 21
0 19 26 -5 50 -24 24 -40 26 -40 5z"
      />
      <path
        d="M480 970 c0 -6 57 -10 150 -10 93 0 150 4 150 10 0 6 -57 10 -150 10
-93 0 -150 -4 -150 -10z"
      />
      <path
        d="M1020 898 c-49 -34 -72 -71 -77 -125 -13 -132 125 -225 244 -164 112
56 119 218 14 288 -47 32 -135 32 -181 1z m62 -39 c16 -8 31 -8 59 1 54 18 73
1 65 -55 -18 -122 -23 -146 -33 -156 -16 -16 -33 -2 -33 25 0 24 -17 46 -37
46 -7 0 -17 -18 -23 -40 -17 -63 -50 -49 -50 21 0 16 -7 46 -15 66 -19 45 -19
68 1 87 18 19 38 20 66 5z"
      />
      <path
        d="M542 874 c-87 -43 -134 -132 -153 -289 -12 -97 -1 -183 34 -258 25
-54 71 -107 92 -107 16 0 34 43 42 96 3 24 7 44 9 44 2 0 18 -9 36 -20 41 -25
54 -25 101 0 20 11 39 20 42 20 3 0 5 -18 5 -40 0 -47 24 -100 44 -100 18 0
61 51 85 99 66 131 45 379 -42 492 -69 90 -189 116 -295 63z m212 -38 c42 -25
75 -72 101 -145 10 -31 11 -41 2 -41 -21 1 -57 34 -75 70 -14 28 -23 35 -47
35 -25 0 -34 -7 -54 -43 -26 -48 -64 -76 -125 -93 -33 -9 -41 -8 -60 10 -12
12 -30 21 -39 21 -23 0 -21 26 7 85 59 124 179 166 290 101z m-4 -131 c0 -8
14 -30 30 -48 26 -30 30 -42 30 -93 0 -60 -25 -131 -58 -167 -29 -32 -91 -59
-121 -52 -36 8 -107 78 -121 120 -6 18 -22 37 -35 43 -26 12 -45 47 -45 83 0
27 36 25 43 -2 5 -20 10 -21 54 -14 90 13 156 54 189 118 16 29 34 36 34 12z
m124 -103 c10 -17 -15 -82 -35 -93 -20 -10 -20 -9 -13 38 3 26 8 51 11 56 6
10 31 9 37 -1z m-421 -126 c9 -7 17 -17 17 -23 0 -5 11 -24 25 -43 26 -35 34
-101 16 -129 -13 -21 -67 67 -80 130 -18 81 -14 92 22 65z m425 -38 c-12 -71
-68 -182 -83 -166 -3 2 -8 25 -11 49 -5 37 -2 52 19 84 27 43 66 85 77 85 4 0
3 -24 -2 -52z"
      />
      <path
        d="M600 450 c0 -5 25 -10 56 -10 34 0 53 4 49 10 -3 6 -28 10 -56 10
-27 0 -49 -4 -49 -10z"
      />
      <path
        d="M40 741 c0 -66 -4 -92 -15 -101 -23 -19 -22 -491 1 -514 37 -38 86 2
83 67 -1 23 -7 48 -12 54 -6 9 -6 13 2 13 8 0 11 52 11 174 0 158 -2 176 -20
199 -24 31 -28 79 -5 71 12 -5 15 3 15 41 0 36 -5 51 -22 66 -13 10 -26 18
-30 19 -5 0 -8 -40 -8 -89z m38 -314 l2 -177 -32 1 c-18 0 -27 3 -20 6 9 3 12
49 12 180 0 161 1 174 18 171 15 -3 17 -21 20 -181z m2 -263 c0 -21 -4 -25
-22 -22 -23 3 -39 38 -19 38 6 0 11 -7 11 -15 0 -8 5 -15 10 -15 6 0 10 9 10
20 0 11 2 20 5 20 3 0 5 -12 5 -26z"
      />
      <path
        d="M250 710 l0 -40 50 0 c28 0 50 5 50 10 0 6 -20 10 -45 10 -38 0 -45
3 -45 20 0 18 7 20 55 20 30 0 55 5 55 10 0 6 -27 10 -60 10 l-60 0 0 -40z"
      />
      <path
        d="M250 555 c0 -35 0 -35 43 -34 l42 2 -35 6 c-26 4 -35 11 -35 26 0 15
9 22 35 26 l35 6 -42 2 c-43 1 -43 1 -43 -34z"
      />
      <path
        d="M1058 480 c3 -61 7 -80 18 -80 10 0 14 13 15 48 0 26 2 62 5 80 3 28
1 32 -19 32 -21 0 -22 -3 -19 -80z"
      />
      <path
        d="M250 375 l0 -35 58 2 57 1 -50 6 c-41 5 -50 9 -50 26 0 16 9 21 45
26 l45 6 -52 1 -53 2 0 -35z"
      />
      <path
        d="M991 348 c-52 -27 -81 -74 -81 -131 0 -46 24 -102 54 -122 19 -14 14
-15 -57 -15 -45 0 -77 -4 -77 -10 0 -6 51 -10 134 -10 121 0 136 2 167 23 45
29 83 106 75 150 -21 110 -121 164 -215 115z m97 -60 c3 -35 5 -37 40 -40 34
-3 37 -6 40 -35 3 -32 2 -33 -37 -33 l-41 0 0 -40 c0 -39 -1 -40 -35 -40 -34
0 -35 1 -35 40 l0 40 -40 0 c-39 0 -40 1 -40 35 0 34 1 35 40 35 l40 0 0 41
c0 39 1 40 33 37 29 -3 32 -6 35 -40z"
      />
      <path
        d="M814 191 c21 -23 76 -45 76 -31 0 9 -71 50 -86 50 -4 0 1 -9 10 -19z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconVinculoAcompanhamento',
}
</script>

<style></style>
